import { RootMasterMessageHub, RootPushSourceManager, RootCustomSourceManager } from '../master';
import PushCode from './pushSource/key';
import { CustomSourceKey, initCustomSource } from './customSource';
import { baseBranch, orderBranch, phfOrderBranch } from './branches';

/**
 * 消息中心 master 部分。负责：
 * 1. 在 Shell 层负责生产消息
 * 2. 向内部 iframe 分发消息
 * 3. 订阅 Shell 层的业务逻辑
 */
export const masterMessageHub = new RootMasterMessageHub(
    new RootPushSourceManager<PushCode>(undefined, baseBranch.push),
    new RootCustomSourceManager<CustomSourceKey>(),
);

/** 消息中心 master 部分（订单分流） */
export const orderMasterMessageHub = masterMessageHub.pipe(orderBranch);

/** 消息中心 master 部分（拼好饭订单分流） */
export const phfOrderMasterMessageHub = masterMessageHub.pipe(phfOrderBranch);

export { PushCode, CustomSourceKey, initCustomSource };

export { PushOrderUserRole } from './branches/baseBranch';
export { NewOrderPushData } from './branches/orderBranch';
export { NewOrderPushData as NewPhfOrderPushData } from './branches/phfOrderBranch';
